<template>
  <div class="blog-social-links">
    <seu-button
      v-if="$isMobile()"
      class="share-button"
      :label="$t('common.share')"
      :button-icon-before="shareIcon"
      @click="toggleSocialMediaShare"
    />
    <seu-button
      v-else-if="!shareActive"
      class="share-button"
      :label="$t('common.share')"
      :button-icon-before="shareIcon"
      @click="shareActive = true"
    />
    <div v-else class="share-icons-button">
      <a target="_blank" :href="`https://www.linkedin.com/sharing/share-offsite/?url=${url}`">
        <img src="../../../assets/icons/square-linkedin.svg" alt="">
      </a>
      <a target="_blank" :href="`https://twitter.com/intent/tweet?url=${url}&text=${post.details.title}`">
        <img src="../../../assets/icons/square-twitter.svg" alt="">
      </a>
      <a target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`">
        <img src="../../../assets/icons/square-facebook.svg" alt="">
      </a>
      <!--          <a href="">-->
      <!--            <img src="../../../assets/icons/square-instagram.svg" alt="">-->
      <!--          </a>-->
      <span style="cursor: pointer" @click="copyURL">
        <img src="../../../assets/icons/link.svg" alt="">
      </span>
    </div>
<!--    <div-->
<!--      v-if="$isMobile()"-->
<!--      class="mobile-share-container"-->
<!--      @click="toggleSocialMediaShare"-->
<!--      tabindex="0"-->
<!--    >-->
<!--      <div class="share-icon-container">-->
<!--        MOBILE SHARE-->
<!--      </div>-->
<!--    </div>-->

<!--    <div-->
<!--      v-else-->
<!--      class="web-share-container"-->
<!--    >-->
<!--      <div @click="copyURL">-->
<!--        copy link-->
<!--      </div>-->
      <div class="success-notification" v-if="showSuccessNotification">Link copied!</div>
<!--      <div v-if="showErrorNotification">Cannot copy link, try again later!</div>-->
<!--      <br>-->
<!--      <a-->
<!--        target="_blank"-->
<!--        :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"-->
<!--      >-->
<!--        share on fb-->
<!--      </a>-->
<!--      <br>-->
<!--      <a-->
<!--        target="_blank"-->
<!--        :href='`https://twitter.com/intent/tweet?url=${url}&text=${post.details.title}`'-->
<!--      >-->
<!--        share on twitter-->
<!--      </a>-->
<!--      <br>-->
<!--      <a-->
<!--        target="_blank"-->
<!--        :href='`https://www.linkedin.com/sharing/share-offsite/?url=${url}`'-->
<!--      >-->
<!--        share on linkedin-->
<!--      </a>-->
<!--    </div>-->

  </div>
</template>
<script>
import SeuButton from "/seu-frontend/components/SeuButton";
export default {
  name: "BlogSocialLinks",
  components: {SeuButton},
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showSuccessNotification: false,
      showErrorNotification: false,
      socialMediaShareDisplayed: false,
      shareIcon: require('../../../assets/icons/share-icon.svg'),
      shareActive: false,

    }
  },
  computed: {
    href(){
     return this.$router.resolve({
       name: "PostDetailsPage",
       params: {
         slug: this.post.details.slug,
         lang: this.$route.params.lang
       }
     }).href
    },
    url() {
      return `${window.location.origin}${this.href}`
    }
  },
  methods: {
    toggleSocialMediaShare() {
      navigator.share({
        url: this.url,
        title: this.post.details.title
      })
    },
    async copyURL() {
      try {
        await navigator.clipboard.writeText(this.url);

        this.showSuccessNotification = true

        setTimeout(() => {
          this.showSuccessNotification = false
        }, 2000)
      }
      catch ($e) {
        this.showErrorNotification = true

        setTimeout(() => {
          this.showErrorNotification = false
        }, 2000)
      }
    }
  }
}
</script>
<style lang="scss">
@import "BlogSocialLinks";
</style>
